<template>
	<p v-if="freeDeliveryText && !(hideWhenFree && freeDeliveryInfo.isFree)"
	   class="free-delivery-message"
	   :class="{'--free': freeDeliveryInfo.isFree}"><template v-if="breakAfterPrice"><template v-for="(part, index) in freeDeliveryTextParts"><br v-if="index" :key="'br' + index"/>{{ part }}</template></template><template v-else>{{ freeDeliveryText }}</template></p>
</template>

<script>
import city from "@/mixins/city";
import freeDelivery from "@/mixins/free-delivery";

/**
 * Мотивирующее сообщение о бесплатной доставке: "Добавьте товаров ещё на X ₽ для бесплатной доставки"
 * либо "Доставка бесплатная". Показывается только когда выбрана зона доставки (см. mixins/free-delivery.js).
 */
export default {
	name: "free-delivery-message",
	mixins: [city, freeDelivery],
	props: {
		form: {},
		// не показывать "Доставка бесплатная" (если рядом уже есть собственный текст об этом)
		hideWhenFree: Boolean,
		// перенос строки после суммы в рублях: "Добавьте товаров ещё на X ₽" / "для бесплатной доставки"
		breakAfterPrice: Boolean,
	},
}
</script>

<style lang="scss">
.free-delivery-message {
	margin: 4px 0 0;
	color: $golden;
}
</style>
